import { create } from "zustand";

const UI_KEY = "mh-rp-ui-v2";
interface PersistedUi { transcriptMessageLimit: number; sidebarCollapsed: boolean; sidebarWidth: number; }
function readPersisted(): PersistedUi {
  try {
    const value = JSON.parse(localStorage.getItem(UI_KEY) ?? "{}") as Partial<PersistedUi>;
    return {
      transcriptMessageLimit: Math.max(40, Math.min(400, Number(value.transcriptMessageLimit) || 120)),
      sidebarCollapsed: value.sidebarCollapsed === true,
      sidebarWidth: Math.max(220, Math.min(480, Number(value.sidebarWidth) || 300)),
    };
  } catch { return { transcriptMessageLimit: 120, sidebarCollapsed: false, sidebarWidth: 300 }; }
}
const initial = readPersisted();
interface UiState extends PersistedUi {
  chatDrafts: Record<string, string>;
  chatScrollOffsets: Record<string, number>;
  setDraft: (archiveId: string, value: string) => void;
  setScrollOffset: (archiveId: string, value: number) => void;
  setLayout: (patch: Partial<PersistedUi>) => void;
}
function persist(state: PersistedUi) { localStorage.setItem(UI_KEY, JSON.stringify(state)); }
export const useUIStore = create<UiState>((set) => ({
  ...initial,
  chatDrafts: {},
  chatScrollOffsets: {},
  setDraft: (archiveId, value) => set((state) => ({ chatDrafts: { ...state.chatDrafts, [archiveId]: value } })),
  setScrollOffset: (archiveId, value) => set((state) => ({ chatScrollOffsets: { ...state.chatScrollOffsets, [archiveId]: value } })),
  setLayout: (patch) => set((state) => {
    const next = { transcriptMessageLimit: patch.transcriptMessageLimit ?? state.transcriptMessageLimit, sidebarCollapsed: patch.sidebarCollapsed ?? state.sidebarCollapsed, sidebarWidth: patch.sidebarWidth ?? state.sidebarWidth };
    persist(next); return next;
  }),
}));
